var _path, _path2, _path3, _circle, _path4, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReviewss = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 112,
  height: 96,
  viewBox: "0 0 112 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 20.658c0-6.03 2.62-10.981 7.86-14.852C13.1 1.936 20.961 0 31.442 0c10.48 0 18.521 1.935 24.123 5.806 5.692 3.87 8.538 9.676 8.538 17.418 0 2.52-.226 4.815-.678 6.886-.452 1.98-1.49 4.095-3.117 6.346-1.536 2.16-3.072 4.095-4.608 5.806-1.445 1.71-3.975 3.96-7.59 6.75a467.569 467.569 0 0 1-17.075 12.963c-5.963 4.23-9.442 6.706-10.435 7.426l-8.267 5.94h32.525c6.234 0 10.662-1.35 13.282-4.05 2.62-2.7 4.472-6.93 5.556-12.692H66L64.645 96H.949V80.338L14.637 67.78c9.305-8.462 15.901-15.978 19.786-22.549 3.885-6.661 5.828-13.952 5.828-21.873 0-8.012-.859-13.457-2.575-16.338-1.717-2.97-4.608-4.456-8.674-4.456s-6.912 1.036-8.538 3.106c-1.626 2.07-2.44 4.05-2.44 5.94 0 1.891.272 3.556.814 4.997h4.066c.722 1.89 1.084 4.185 1.084 6.886 0 2.61-1.13 4.905-3.388 6.886-2.26 1.89-5.24 2.835-8.945 2.835-3.704 0-6.595-1.17-8.673-3.51C.994 27.275 0 24.259 0 20.658Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#265682",
  strokeWidth: 4,
  d: "M42 11v5M70 11v5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68 16H44v5h-4v-5h-7v47h46V16h-7v5h-4v-5Zm-8.885 19.712L56 30l-3.115 5.712-6.396 1.198 4.47 4.728-.837 6.452L56 45.3l5.878 2.79-.837-6.452 4.47-4.728-6.396-1.198Z",
  fill: "#265682"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 86.541,
  cy: 62,
  r: 21,
  fill: "#D6BB96"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M86.541 45v4M86.54 53v8M76.54 68l10-6M86.541 74v4M70 62h4M99 62h4"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 86.541,
  cy: 62,
  r: 3,
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 33,
  y1: 0,
  x2: 33,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEFF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF2",
  stopOpacity: 0
})))));
export default SvgReviewss;